// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__7R0XF","calendarButtons":"ClockData_calendarButtons__2FTMG"};